
// const API_URL = 'https://lampbackdev.herokuapp.com/api'
const API_URL = process.env.VUE_APP_BACKEND
export const APPLICANT_DASHBOARD = process.env.VUE_APP_APPLICANTDASHBOARD

export const loginUser = ` ${API_URL}/user/login`
export const wakeUpServer = ` ${API_URL}/`
export const getApplicantByEmail = (applicantEmail) => `${API_URL}/elder/getApplicantByEmail/${applicantEmail}/`;
export const getAllApplicants = () => `${API_URL}/elder/getAllApplicants`;
export const getAllApplicantsByBatch = (batch) => `${API_URL}/elder/getAllApplicants/${batch}`;
export const getAllInfoSessions = () => `${API_URL}/infoSession/getAllInfoSessions`;
export const getAllInfoSessionsList = () => `${API_URL}/infoSession/getInfoSessionsList`;
export const getInfoSessionByID = (id) => `${API_URL}/infoSession/getInfoSession/${id}`;


export const inviteForInterview = `${API_URL}/interviewInvite/inviteApplicant`;
export const startInterview = (applicantEmail) => `${API_URL}/interview/startInterview/${applicantEmail}/`;
export const stopInterview = (applicantEmail) => `${API_URL}/interview/stopInterview/${applicantEmail}/`;
export const sendInteractionComment = (applicantEmail) => `${API_URL}/interaction/addComment/${applicantEmail}/`;
export const getAllInteractionComment = (applicantEmail) => `${API_URL}/interaction/getComments/${applicantEmail}/`;
export const getScheduleInvite = (applicantEmail) => `${API_URL}/interviewInvite/getInterviewInvite/${applicantEmail}/`;
export const sendInterviewDecision = (applicantEmail, decision) => `${API_URL}/elder/sendInterviewDecision/${applicantEmail}/${decision}/`;
export const cancelInterview = (applicantEmail) => `${API_URL}/interview/cancelInterview/${applicantEmail}/`;
export const makeFinalApplicationDecision = (applicantEmail) => `${API_URL}/interview/makeFinalDecision/${applicantEmail}/`;
export const getCompletedInterview = (applicantEmail) => `${API_URL}/interview/viewInterview/${applicantEmail}/`;
export const registerApplicant = `${API_URL}/elder/apply`;
export const uploadPayment = `${API_URL}/elder/uploadNewPayment`;
export const getAllCohort = `${API_URL}/cohort/getAvailableCohorts`;
export const assignCohort = `${API_URL}/elder/assignCohort`;
export const withdrawApplicant = `${API_URL}/elder/withdrawApplication`;
export const rescindWithdrawApplicant  = (applicantEmail) => `${API_URL}/elder/rescindWithdraw/${applicantEmail}`;
export const rescindInterview = (applicantEmail) => `${API_URL}/elder/rescindDecision/${applicantEmail}/`;
export const checkInNative = (applicantEmail) => `${API_URL}/elder/checkNativeIn/${applicantEmail}`;
export const getEnrollmentForm = (applicantEmail) => `${API_URL}/getEnrollmentForm/${applicantEmail}`;

export const markApplicantAsNonResponsive = (applicantEmail) => `${API_URL}/elder/markAsNonResponsive/${applicantEmail}/`;
export const markApplicantAsResponsive = (applicantEmail) => `${API_URL}/elder/markAsResponsive/${applicantEmail}/`;


//